"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _check = _interopRequireDefault(require("@spothero/icons/check"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var Checkbox = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Checkbox, _PureComponent);

  var _super = _createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Checkbox);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      validationState: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onInvalid", function (evt) {
      evt.preventDefault();
      var onInvalid = _this.props.onInvalid;
      var validationState = evt.currentTarget.validity;

      _this.setState({
        validationState: validationState
      });

      if (onInvalid) {
        onInvalid(validationState);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onChange", function (evt) {
      var onChange = _this.props.onChange;

      _this.setState({
        validationState: null
      });

      if (onChange) {
        onChange(evt);
      }
    });
    var id = props.id,
        toggle = props.toggle,
        label = props.label;

    if (!id) {
      throw new Error("The prop 'id' is required to make Checkbox accessible for users using assistive technologies such as screen readers. Check the render method of Checkbox.");
    }

    if (!toggle && !label) {
      throw new Error("The label prop is required when using a Checkbox that isn't a toggle.");
    }

    return _this;
  }

  (0, _createClass2.default)(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._input.addEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._input.removeEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "_renderIcon",
    value: function _renderIcon() {
      return this.props.icon;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          className = _this$props.className,
          name = _this$props.name,
          id = _this$props.id,
          value = _this$props.value,
          defaultChecked = _this$props.defaultChecked,
          required = _this$props.required,
          disabled = _this$props.disabled,
          toggle = _this$props.toggle,
          error = _this$props.error;
      var validationState = this.state.validationState;
      var isValid = validationState ? validationState.valid : true;
      var classes = (0, _classnames.default)('Checkbox', {
        'Checkbox-toggle': toggle
      }, 'FormElement', {
        'FormElement-contains-error': !isValid
      }, className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "FormElement-control"
      }, /*#__PURE__*/_react.default.createElement("input", {
        ref: function ref(node) {
          _this2._input = node;
        },
        id: "Checkbox-".concat(id),
        className: "FormElement-item",
        type: "checkbox",
        name: name,
        defaultChecked: defaultChecked,
        required: required,
        disabled: disabled,
        value: value,
        onChange: this._onChange
      }), this._renderIcon(), !toggle && /*#__PURE__*/(0, _react.cloneElement)(label, {
        htmlFor: "Checkbox-".concat(id)
      }), toggle && /*#__PURE__*/_react.default.createElement("span", {
        className: "Label"
      })), !isValid && error);
    }
  }]);
  return Checkbox;
}(_react.PureComponent);

exports.default = Checkbox;
(0, _defineProperty2.default)(Checkbox, "defaultProps", {
  value: 'on',
  icon: /*#__PURE__*/_react.default.createElement(_check.default, null)
});